import * as React from "react";
import { IconProps } from "../types";

const BoltSpeed2Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
        {...props}
      >
        <path
          d="M11.15 16.127L16.547 8.13999C16.659 7.97399 16.54 7.74999 16.34 7.74999H11.561L12.407 2.04299C12.444 1.79099 12.114 1.66199 11.971 1.87399L6.57399 9.86099C6.46199 10.027 6.58099 10.251 6.78099 10.251H11.56L10.714 15.958C10.677 16.21 11.007 16.339 11.15 16.127Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.75 9H4"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.25 5.75H5.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.25 12.25H5.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default BoltSpeed2Icon;
